import { Popover } from 'antd'
import { WarningFilled } from '@ant-design/icons'
import React from 'react'
import './invalid-connection-label.scss'

type InvalidConnectionLabelProps = {
    content?: React.ReactNode
}

export const InvalidJourneyComponent = ({ content }: InvalidConnectionLabelProps) => {
    const accessibleName = typeof content === 'string' ? content : 'Invalid connection'
    return (
        <Popover
            overlayClassName="invalid-label-popover"
            className="nodrag nopan"
            trigger={['hover', 'focus']}
            content={content || 'Invalid connection'}
        >
            <button
                type="button"
                className="nodrag nopan invalid-journey-trigger"
                aria-label={accessibleName}
            >
                <WarningFilled aria-hidden />
            </button>
        </Popover>
    )
}
